<script lang="ts" setup>
import { computed } from 'vue'

defineProps({
	isError: {
		type: Boolean,
		default: false,
	},
	errorMessage: {
		type: String,
		default: '',
	},
	placeholder: {
		type: String,
		default: '',
	},
	modelValue: {
		type: String,
		required: true,
	},
	type: {
		type: String,
		default: 'text',
	},
	isShowTrailing: {
		type: Boolean,
		default: false,
	},
})

const emit = defineEmits(['update:modelValue'])

const isSafari = computed(() => {
	// safari has default password suggest icon, need padding
	return /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
})

function update(event: Event) {
	emit('update:modelValue', (event.target as HTMLInputElement).value)
}
</script>

<template>
	<div
		class="bs-text-field-outline"
		:class="{ 'bs-text-field-outline--error': isError }"
	>
		<input
			class="bs-text-field-outline__input"
			:class="{
				'bs-text-field-outline__input--filled': !!modelValue,
				'bs-text-field-outline__input--padding': isSafari,
			}"
			:type="type"
			:placeholder="placeholder"
			:value="modelValue"
			@input="update"
			autocomplete="off"
		/>
		<span class="bs-text-field-outline__trailing">
			<slot name="trailing" />
		</span>
		<span
			v-if="errorMessage !== '' && isError"
			class="bs-text-field-outline__message"
		>
			{{ errorMessage }}
		</span>
	</div>
</template>
